<template>
    <v-container class="bg-white" fluid grid-list-sm>
        <v-layout>
            <v-flex class="mt-5">
                <v-img :src="require('./../../../assets/img/devis/g_vie.png')"></v-img>
            </v-flex>
        </v-layout>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <v-layout align-end class="content-justify bg-white text-center" justify-content-center row style="margin-bottom:10%" wrap v-if="isDesktop()">
            <v-flex class="justify-content-center row" pb-3 xs12>
                <v-stepper v-model="e1" class="elevation-0 pa-0">
                    <v-stepper-header class="row elevation-0" style="width: 850px!important;display: inline-flex">
                        <v-stepper-step color="#ffa409" :complete="e1 > 1" step="1">Simulation</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step color="#ffa409" :complete="e1 > 2" step="2">Contractant</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step color="#ffa409" :complete="e1 > 3" step="3">Récapitulatif</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-item>
                        <v-stepper-content step="1">
                            <v-layout class="mb-5 column" height="200px" elevation="24">
                                <v-flex text-center v-if="isDesktop()">
                                    <h1 class="text-assuraf policeLato font-weight-bold">L'assurance bétail</h1>
                                </v-flex>
                                <v-flex class="justify-content-center row mb-3 ml-1 mr-1">
                                    <div class="justify-content-center column" style="background:#EFEFEF;width:900px!important;height:auto;border-radius: 30px;box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2), 0 10px 10px rgba(0, 0, 0, 0.2);" v-show="Capital">
                                        <div class="justify-content-center row ml-5 mr-5 mb-3" style="margin: 10px">
                                            <div class="mb-2" style="width: 250px">
                                                <h4 id="titre">TYPE</h4>
                                                <div class="select" id="input-number" style="margin-top:42px">
                                                    <select @change="onChangeType()" name="slct" id="slct" v-model="type" >choisir la race
                                                        <option  value="null" selected disabled>choisir la race</option>
                                                        <option v-for="item in details" :key="item" :value="item.type">{{item.type}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            
                                            <div class="ml-2 mb-2" style="width: 250px">
                                                <h4 id="titre">AGE</h4>
                                                <div class="select" id="input-number" style="margin-top:42px">
                                                    <select name="slct" id="slct" v-model="age">
                                                        <option value="null" selected disabled>choisir l'âge</option>
                                                        <option v-for="item in tabAge.age" :key="item" :value="item">{{item}}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="ml-2 mb-2" style="width: 250px">
                                                <h5 id="titre">VALEUR</h5>
                                                <input @keyup="CalculTaxeRente()" v-money="money"  style="margin-top:42px" class="input-number" v-model="valeur" type="text" placeholder="Saisir la valeur">
                                            </div>
                                        </div>
                                        <div class="justify-content-center row" v-if="monthly_payment!=null">
                                            <div class="mt-5 mb-3 justify-content-center column" style="background: #fff;border-radius: 20px;width: 250px">
                                                <h4>
                                                    <p> Prime nette </p>
                                                </h4>
                                                <h3 style="font-weight: bold;color:#ffa409">
                                                    {{monthly_payment.toLocaleString()}} FCFA
                                                </h3>
                                            </div>
                                        </div>
                                        <button v-if="Simule" class="mb-3 button ml-3" @click="GetPrimeNette()">simuler</button>
                                        <button v-if="SkipSimule" class="mb-3 button ml-3" @click="DevisNextStep()">Continuer</button>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <div class="container">
                                <article class="justify-content-center row">
                                    <!-- =================== PARTIE CONTRACTANT =================
                                         =================== PARTIE CONTRACTANT =================
                                         =================== PARTIE CONTRACTANT ================= -->
                                    <section :class="animation" style="background: #efefef">
                                        <h2>SOUSCRIPTEUR</h2>
                                        <p class="font-weight-bold" style="color: red;margin-bottom: -5px">les formats acceptés : pdf, jpeg, png, doc </p>
                                        <div class="input-fields">
                                            <div class="justify-content-center row" style="width: 1000px;height: 500px">
                                                <div class="justify-content-center row">
                                                    <div class="input-group">
                                                        <div class="wrap mt-2" style="z-index: 3">
                                                            <div class="valign-middle">
                                                                <div class="form-group">
                                                                    <label for="file" class="sr-only">Inserer Ninea</label>
                                                                    <input type="file" ref="Ninea">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="req-mark">!</div>
                                                    </div>

                                                    <div class="input-group ml-3">
                                                        <div class="wrap mt-2" style="z-index: 3">
                                                            <div class="valign-middle">
                                                                <div class="form-group">
                                                                    <label for="file" class="sr-only">Inserer RC</label>
                                                                    <input type="file" ref="Rc">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="req-mark">!</div>
                                                    </div>
                                                </div>

                                                <div class="justify-content-center row" style="margin-top: -12%">
                                                    <div class="input-group">
                                                        <div class="wrap mt-2" style="z-index: 3">
                                                            <div class="valign-middle">
                                                                <div class="form-group">
                                                                    <label for="file" class="sr-only">Inserer DAO</label>
                                                                    <input type="file" ref="Dao">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="req-mark">!</div>
                                                    </div>

                                                    <div class="input-group ml-3">
                                                        <div class="wrap mt-2" style="z-index: 3">
                                                            <div class="valign-middle">
                                                                <div class="form-group">
                                                                    <label for="file" class="sr-only">Inserer CNI</label>
                                                                    <input type="file" ref="Cni">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="req-mark">!</div>
                                                    </div>
                                                </div>

                                                <div class="justify-content-center row" style="margin-top: -14%">
                                                    <div class="input-group">
                                                        <div class="wrap mt-2" style="z-index: 3">
                                                            <div class="valign-middle">
                                                                <div class="form-group">
                                                                    <label for="file" class="sr-only">Inserer Lettre Type</label>
                                                                    <input type="file" ref="LettreType">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="req-mark">!</div>
                                                    </div>

                                                    <div class="input-group ml-3">
                                                        <label>Date d'effet :</label>
                                                        <date-picker class="mt-2" style="float:right;display:flex;right: 33px;position: relative;z-index: 2" v-model="ContractantFields.dateNaissance" placeholder="Cliquer ici" valueType="format" format="YYYY-MM-DD" :min="new Date().toISOString().substr(0, 10)" lang="fr-fr"></date-picker>
                                                        <div class="req-mark">!</div>
                                                    </div>
                                                </div>

                                                <div class="justify-content-center row" style="margin-top: -16%">
                                                    <div class="input-group">
                                                        <input @keypress="onlyNumber" v-model="ContractantFields.Duree" value="" type="number" required="required" placeholder="Durée en jours">
                                                        <label>Durée :</label>
                                                        <div class="req-mark">!</div>
                                                    </div>

                                                    <div class="input-group ml-3">
                                                        <input v-model="Beneficiaire" value=""  type="text" required="required">
                                                        <label>Bénéficiaire :</label>
                                                        <div class="req-mark">!</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mb-3" style="margin-top: -15%">
                                            <button class="button-blue" @click="e1=1">Retour</button>
                                            <button class="button ml-3" @click="upload()">Continuer</button>
                                        </div>
                                    </section>
                                </article>
                            </div>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                             <v-layout align-end class="content-justify bg-white text-center" justify-content-center>
                                <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
                                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                                <!-- ========================================================================================= -->
                                <v-layout row wrap justify-content-center pb-3 v-if="isDesktop()" style="margin-bottom:10%">

                                    <!--========= Details Assurance cas Bétails DESKTOP ================-->
                                    <!--========= Details Assurance cas Bétails DESKTOP ================-->
                                    <!--========= Details Assurance cas Bétails DESKTOP ================-->
                                    <!--========= Details Assurance cas Bétails DESKTOP ================-->
                                    <v-flex justify-content-center row style="z-index: 0!important;">
                                        <v-flex justify-content-center xs11 sm10 md11 lg11 class="row block-content elevation-0 row-container mt-3 bg-transparent grey lighten-3 border-radius">
                                            <v-flex xs11 sm10 md11 lg11 pt-3 class="justify-content-center row">
                                                <p class="font-weight-black headline policeLato">Détails de l'assurance</p>
                                            </v-flex>
                                        <v-flex justify-content-center xs11 sm10 md11 lg11 class="mt-3 row block-content elevation-0 row-container bg-transparent grey lighten-3 border-radius">
                                            <v-layout class="bg-light pa-2 border-radius">
                                                <v-flex>
                                                    <v-layout class="row justify-content-center ml-3 mr-3">
                                                        <v-flex>
                                                            <v-menu :close-on-content-click="false" v-model="menu" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                                                <v-text-field readonly slot="activator" placeholder="Date de prise d'effet" v-model="dateEffet" prepend-inner-icon="event" @change="dateDiff()"></v-text-field>
                                                                <v-date-picker @change="dateDiff()" color="#ffa409" v-model="dateEffet" @input="menu = false" :min="new Date().toISOString().substr(0, 10)" locale="fr-fr"></v-date-picker>
                                                            </v-menu>
                                                        </v-flex>

                                                        <v-flex>
                                                            <v-text-field slot="activator" v-model="dateEcheance" disabled placeholder="Date d'échéance" prepend-inner-icon="event"></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        
                                            <v-flex justify-content-center xs12 sm12 md12 lg12 class="row block-content elevation-0 row-container bg-transparent">
                                                <v-flex xs12 sm12 md12 lg12 class="table-responsive">
                                                    <div>
                                                        <ul class="mr-2 to-center mt-1 mb-3 policeLato justify-center row" style="width: 500px; margin-left:300px">

                                                            <li class="to left font-weight-regular subheading">Type Betail :
                                                                <span class="ml-1 to-right" style="color: #ffa409">{{type}}</span>
                                                            </li>
                                                            <li class="ml-3 to left font-weight-regular subheading">Age :
                                                                <span class="ml-1 to-right" style="color: #ffa409">{{age}}</span>
                                                            </li>
                                                            <li class="ml-3 to left font-weight-regular subheading">Valeur :
                                                                <span class="ml-1 to-right" style="color: #ffa409">{{valeur}} FCFA</span>
                                                            </li>
                                                            <li class="ml-3 to left font-weight-regular subheading" v-if="monthly_payment!=null">Prime nette :
                                                                <span class="ml-1 to-right" style="color: #ffa409">{{monthly_payment.toLocaleString()}} FCFA</span>
                                                            </li>
                                                            <li class="ml-3 to left font-weight-regular subheading">Datte d'effet :
                                                                <span class="ml-1 to-right" style="color: #ffa409">{{ContractantFields.dateNaissance}}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </v-flex>
                                            </v-flex>
                                        </v-flex>



                                        <v-layout column>
                                            <v-flex class="justify-content-center row ml-1 mr-1 mb-3 mt-2">
                                                <button class="button-blue" @click="e1 = 2">Retour</button>
                                                <button class="button ml-3" @click="sendData()">Valider</button>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <!--======================================= End Detail block if Automobile DESKTOP ========================================================-->
                                </v-layout>
                            </v-layout>
                        </v-stepper-content>
                    </v-stepper-item>
                </v-stepper>
            </v-flex>
        </v-layout>
        <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
        <login-form :visible="showLoginForm" @close="showLoginForm=false"></login-form>
    </v-container>
</template>
<script>

    import ville from "./../../../common/ville";
    import dayjs from "dayjs";
    import LoginForm from '././../../auth/Login';
    import cnaasData from '../../../common/cnaas'

    export default {
        name: 'Devis_nsia',
        components: {
            LoginForm
        },
        data() {
            return {
                details : [],
                tabAge : [],
                Data: [],
                typeBetail: null,
                oldDate: null,
                bottomPushNotif: false,
                disableDateAssure: true,
                Modalite: null,
                Assureur: '',
                Simule: true,
                SkipSimule: false,
                money: {
                    thousands: ' ',
                    precision: false,
                    masked: false,
                },
                choixOffre: null,
                choixOffreFinale: null,
                dateNaiss: null,
                duree: null,
                Capital: true,
                Mensualite: false,
                Capi_souhaite: null,
                rente_an: null,
                pourcent: [],
                choixCapital: {
                    Capital: null,
                    Mensuel: null,
                },
                dateEffet: null,
                dateEcheance: null,
                e1: 0,
                elevation: 2,
                activeStep: 0,
                checkbox: false,
                errors: {},
                aStorMap: false,
                disable: false,
                valide: null,
                age: null,
                QuestionSwitch: {
                    Q1: null,
                    Q2: null,
                    Q3: null,
                    Q4: null,
                    Q5: null,
                    Q6: null,
                    Q7: null,
                },
                QuestionNext: {
                    Q: true,
                    Q1: false,
                    Q2: false,
                    Q3: false,
                    Q4: false,
                    Q5: false,
                    Q6: false,
                    Q7: false,
                },

                // numTelephone : '' ,
                amenities: [1, 4],
                genre: null,

                fraisLiv: 0,
                fraisPaiement: 0,
                Testons: false,
                itemsGenre: ["Homme", "Femme"],
                adresselivraison: "",
                autoHeight: true,
                x: null,
                dialogAlert: false,
                Devis_pour_souscription: [],
                mode_livraison: null,
                listVille: ville,

                menuDelivrance: false,
                Calculated_response: null,
                monthly_payment: null,
                mode_payement: null,
                notifDeviParMail: null,
                countries: null,
                ville: null,
                quartier: "",
                listegaranties: [],
                marque: null,
                tableau_info_passager: [],
                nbPassager: null,
                frais_livraison: null,
                branche: null,
                continue_btn: false,
                dialogInfoPassager: false,
                dialog: false,
                city: null,
                datePickerDateNais: false,
                IsPaid: false,
                adresse: false,
                livePaper: false,
                checked: false,
                showLoginForm: false,
                animation: 'animate-in',
                NomAssure: null,
                isContractant: true,
                isAssure: false,
                isBenef: false,
                Questionnaire: false,
                QuestionnaireSuite: false,
                isPayment: false,
                menu: false,
                Capi: 0,
                Mensu: 0,
                ToastTabSucess: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 4000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                }, // Customized options for success toast
                ToastTabError: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 4000,
                    fitToScreen: true,
                    type: 'error'
                }, // Customized options for error toast
                // Contractant fields
                ContractantFields: {
                    Cni: null,
                    Genre: null,
                    Situation: null,
                    Nom: null,
                    Prenom: null,
                    dateNaissance: null,
                    LieuNaissance: null,
                    Profession: null,
                    Adresse: null,
                    Telephone: null,
                    Email: null
                },
                // Assure fields
                AssureFields: {
                    Nom: null,
                    Prenom: null,
                    dateNaissance: null,
                    LieuNaissance: null,
                    Profession: null,
                    Adresse: null,
                    Telephone: null,
                    Email: null,
                    LieuExe: null,
                },
                // Beneficiaire fields
                BenefiFields: {
                    Nom: null,
                    Prenom: null,
                    dateNaissance: null,
                    LieuNaissance: null,
                    Filiation: '',
                },
                // Questionnaire fields
                QuestionsFieldsSuite: {
                    taille: null,
                    poids: null,
                    ArretTravailW: null,
                    ArretTravailM: null,
                    InterompTravailDate: null,
                    InterompTravailMotif: null,
                    InterompTravailDuree: null,
                    SejourDate: null,
                    SejourMotif: null,
                    SejourDuree: null,
                    interventionDate: null,
                    interventionMotif: null,
                    infirm: null,
                    infirmDate: null,
                    infirmTaux: null,
                    infirmServie: null,
                    infectionNbre: null,
                    infectionDate: null,
                    infectRespiratoire: null
                },

                formSteps: [
                    {
                        title: "CONTRACTANT",
                        fields: [
                            {valid: true},
                        ]
                    },
                    {
                        title: "ASSURE",
                        fields: [
                            {valid: true},
                        ]
                    },
                    {
                        title: "BENEFICIAIRE",
                        fields: [
                            {valid: true},
                        ]
                    },
                    {
                        title: "QUESTIONNAIRE MEDICAL",
                        fields: [
                            {valid: true}
                        ]
                    },
                    {
                        title: "QUESTIONNAIRE MEDICAL SUITE",
                    }
                ],
                CreatedDevis: null,
            }
        },
        methods: {

            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },

            isDesktop: function () {
                if (screen.width > 768) {
                    return true;
                } else {
                    return false;
                }
            },

            dateDiff: function () {
                if (this.dateEffet === '' && this.duree === '') this.dateEcheance = '';
                let inter = dayjs(this.dateEffet).add(this.duree, 'day').format('YYYY-MM-DD');
                this.dateEcheance = dayjs(inter).add(-1, 'day').format('YYYY-MM-DD')
            },

            yearsDiffContractant() {
                const date1 = dayjs(this.ContractantFields.dateNaissance);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age <0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.ContractantFields.dateNaissance = null

                } else if (this.age) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
                        this.ContractantFields.dateNaissance = null
                    }
                }
                else if (this.age<=0) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
                        this.ContractantFields.dateNaissance = null
                    }
                }
            },

            onlyNumber($event) {
                let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
                if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                    $event.preventDefault();
                }
            },

            //Prépare Objet d'envois des fichiers de formulaire du devis sonac betails sur l'API
            upload(){
                if (this.$refs.Ninea.files[0] && this.$refs.Rc.files[0] && this.$refs.Dao.files[0] && 
                    this.$refs.Cni.files[0] && this.$refs.LettreType.files[0] && this.ContractantFields.dateNaissance 
                    && this.ContractantFields.Duree && this.Beneficiaire) {

                    let fileNinea = this.$refs.Ninea.files[0];
                    let fileRc = this.$refs.Rc.files[0];
                    let fileDao = this.$refs.Dao.files[0]
                    let fileCni = this.$refs.Cni.files[0]
                    let fileLettreType = this.$refs.LettreType.files[0]

                    const Contractant = {
                        datenaissance: this.ContractantFields.dateNaissance,
                        Duree: this.ContractantFields.Duree,
                        Beneficiaire: this.Beneficiaire
                    };
                    
                    this.data = {
                        Ninea :fileNinea,
                        Rc :fileRc,
                        Dao :fileDao,
                        Cni :fileCni,
                        age : this.age,
                        TypeBetail : this.type,
                        Valeur : this.valeur,
                        LettreType :fileLettreType,
                        date : this.ContractantFields.dateNaissance,
                        duree : this.ContractantFields.Duree
                    }
                    this.e1 = 3
                    this.dateEffet = this.ContractantFields.dateNaissance
                    this.duree = this.ContractantFields.Duree
                    this.dateDiff()
                    
                }else {
                    this.$toasted.show( "Champs obligatoires !", this.ToastTabError)
                }
            },

            getData () {
                this.details = cnaasData[0].betails
                console.log("data", this.details)
            },

            CalculTaxeRente(){
                this.Simule = true
                this.SkipSimule = false
            },

            onChangeType() {
                for (let i = 0; i < this.details.length; i++) {
                    if (this.type == this.details[i].type) {
                        this.tabAge = this.details[i];
                    }
                }
            }, 

            GetPrimeNette () {
                if (this.type && this.age && this.valeur) {
                    for (let i = 0; i < this.details.length; i++) {
                        if (this.type == this.details[i].type) {
                            this.pourcent = this.details[i].pourcentage
                            this.monthly_payment = (Number(this.valeur.replace(/[^0-9.-]+/g, "")) * this.pourcent) / 100 
                            this.SkipSimule = true
                            this.Simule = false
                        }
                    }
                } else {
                    this.$toasted.show( "Champs obligatoires !", this.ToastTabError)
                }
                
            },


            DevisNextStep(){
                this.e1 = 2
            },

            sendData () {
                console.log("sendData", this.data)
            }
        },
        mounted : function () {
            window.scrollTo(0, 0);
            this.getData()

            $('input[type="file"]').each(function() {
                // get label text
              let label = $(this).parents('.form-group').find('label').text();
              label = (label) ? label : 'Upload File';

                // wrap the file input
                $(this).wrap('<div class="input-file"></div>');
                // display label
                $(this).before('<span class="btn">'+label+'</span>');
                // we will display selected file here
                $(this).before('<span class="file-selected"></span>');

                // file input change listener
                $(this).change(function(e){
                    // Get this file input value
                  const val = $(this).val();

                  // Let's only show filename.
                    // By default file input value is a fullpath, something like
                    // C:\fakepath\Nuriootpa1.jpg depending on your browser.
                  const filename = val.replace(/^.*[\\\/]/, '');

                  // Display the filename
                    $(this).siblings('.file-selected').text(filename);
                });
            });

// Open the file browser when our custom button is clicked.
            $('.input-file .btn').click(function() {
                $(this).siblings('input[type="file"]').trigger('click');
            });
        }
    }
</script>

<style lang="less" scoped>
    @import "./../../../assets/css/button.css";

    .file-btn {
        color: #ffa409 !important;
        text-transform: lowercase;
    }

    .text-assuraf {
        color: #ffa409;
        font-family: Georgia !important;
    }
    article {
        margin: 10px;
        width: calc(100% - 20px);
        min-height: 480px;
    }

    article .progress-step {
        justify-content: center;
        align-items: center;
        position: relative;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-bottom: 20px;
        color: #fff;
        background-color: #df5c2e;
        font-weight: bold;
    }
    article .progress-step.active {
        background-color: #df5c2e;
    }
    article .progress-step.active ~ .progress-step {
        color: #555;
        background-color: #ccc;
    }
    article .progress-step.active ~ .progress-step::before {
        background-color: #ccc;
    }
    article .progress-step:before {
        content: '';
        position: absolute;
        top: -20px;
        width: 2px;
        height: 20px;
        background: #df5c2e;
        z-index: 10;
    }
    article .progress-step:first-child::before {
        display: none;
    }
    article section {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: auto;
        background-color: #fff;
        box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2), 0 10px 10px rgba(0, 0, 0, 0.2);
        border-radius: 30px!important;
    }
    article section h2 {
        font-size: 1.6rem;
        color: #ffa409;
        margin: 0;
        padding: 20px;
    }
    article section .input-fields {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
    }
    article section .input-fields-mobile {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
    }
    article section .input-container {
        position: relative;
        padding: 30px 20px 20px 20px;
        width: 100%;
        align-content: center;

    }

    article section .actions {
        margin: 30px 0 0 0;
    }
    article section .actions button {
        font-family: 'Noto Sans', sans-serif;
        outline: none;
        border: none;
        color: #fff;
        background-color: #ffa409;
        font-size: 1.15rem;
        padding: 5px 20px;
        margin: 0 10px;
        text-transform: uppercase;
        border-radius: 30px;
        cursor: pointer;
    }
    .animate-out {
        transform-origin: right;
        animation: out 0.6s ease-in-out;
    }
    .animate-in {
        transform-origin: right;
        animation: in 0.6s ease-in-out;
    }
    .animate-out-back{
        transform-origin: bottom;
        animation: out 0.6s ease-in-out;
    }
    .animate-in-back {
        transform-origin: left;
        animation: in 0.6s ease-in-out;
    }
    .animate-wrong {
        animation: wrong 0.4s ease-in-out;
    }
    @keyframes out {
        0% {
            transform: translateY(0px) rotate(0deg);
        }
        /*60% {
            transform: rotate(10deg);
        }*/
        100% {
            transform: translateY(400px);
        }
    }
    @keyframes in {
        0% {
            opacity: 0;
            transform: rotateY(90deg);
        }
        100% {
            opacity: 1;
            transform: rotateY(0deg);
        }
    }
    @keyframes wrong {
        0% {
            transform: translateX(0);
        }
        20% {
            transform: translateX(40px);
        }
        40% {
            transform: translateX(20px);
        }
        60% {
            transform: translateX(40px);
        }
        80% {
            transform: translateX(20px);
        }
        100% {
            transform: translateX(0);
        }
    }



    [type="radio"]:checked,
    [type="radio"]:not(:checked) {
        position: absolute;
        left: -9999px;
    }
    [type="radio"]:checked + label,
    [type="radio"]:not(:checked) + label
    {
        position: relative;
        padding-left: 28px;
        cursor: pointer;
        line-height: 20px;
        display: inline-block;
        color: #666;
    }
    [type="radio"]:checked + label:before,
    [type="radio"]:not(:checked) + label:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 18px;
        height: 18px;
        border: 1px solid #ddd;
        border-radius: 100%;
        background: #fff;
    }
    [type="radio"]:checked + label:after,
    [type="radio"]:not(:checked) + label:after {
        content: '';
        width: 12px;
        height: 12px;
        background: #ffa409;
        position: absolute;
        top: 4px;
        left: 4px;
        border-radius: 100%;
        -webkit-transition: all 0.2s ease;
        transition: all 0.2s ease;
    }
    [type="radio"]:not(:checked) + label:after {
        opacity: 0;
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    [type="radio"]:checked + label:after {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1);
    }



    *:focus {
        outline: none;
    }

    body {
        background-color: #efefef;
        padding: 70px;
        font-family: "Open Sans", "Arial", snas-serif;
    }

    .input-group {
        display: block;
        width: 441px;
        max-width: 100%;
        height: 50px;
        margin-top: 30px;
        border: 0;
        background-color: #ffffff;
        border-bottom-left-radius: 41px;
        border-bottom-right-radius: 41px;
        border-top-left-radius: 41px;
        border-top-right-radius: 0;
        box-shadow: 0 17px 40px 0 rgba(75, 128, 182, 0.07);
        margin-bottom: 22px;
        position: relative;
        font-size: 17px;
        color: #a7b4c1;
        transition: opacity 0.2s ease-in-out, filter 0.2s ease-in-out,
        box-shadow 0.1s ease-in-out;
    }
    .input-group-mobile {
        display: block;
        width: 100%;
        max-width: 100%;
        height: 50px;
        margin-top: 30px;
        border: 0;
        background-color: #ffffff;
        border-bottom-left-radius: 41px;
        border-bottom-right-radius: 41px;
        border-top-left-radius: 41px;
        border-top-right-radius: 0;
        box-shadow: 0 17px 40px 0 rgba(75, 128, 182, 0.07);
        margin-bottom: 22px;
        position: relative;
        font-size: 17px;
        color: #a7b4c1;
        transition: opacity 0.2s ease-in-out, filter 0.2s ease-in-out,
        box-shadow 0.1s ease-in-out;
    }

    .input-group:hover {
        box-shadow: 0 14px 44px 0 rgba(255,164,9, 0.077);
    }
    .input-group-mobile:hover {
        box-shadow: 0 14px 44px 0 rgba(255,164,9, 0.077);
    }

    .input-group input {
        position: absolute;
        border: 0;
        box-shadow: none;
        background-color: rgba(255, 255, 255, 0);
        top: 0;
        margin-top: -20px;
        height: 65px;
        width: 100%;
        padding: 0 53px;
        box-sizing: border-box;
        z-index: 3;
        display: block;
        color: #1a6fc4;
        font-size: 17px;
        font-family: "Oxygen", sans-serif;
        transition: top 0.1s ease-in-out;
    }
    .input-group-mobile input {
        position: absolute;
        border: 0;
        box-shadow: none;
        background-color: rgba(255, 255, 255, 0);
        top: 0;
        margin-top: -20px;
        height: 65px;
        width: 100%;
        padding: 0 53px;
        box-sizing: border-box;
        z-index: 3;
        display: block;
        color: #1a6fc4;
        font-size: 17px;
        font-family: "Oxygen", sans-serif;
        transition: top 0.1s ease-in-out;
    }

    .input-group input::placeholder {
        color: rgba(0, 0, 0, 0);
    }
    .input-group-mobil input::placeholder {
        color: rgba(0, 0, 0, 0);
    }

    .input-group input:focus,
    .input-group input:not(:placeholder-shown) {
        top: 17px;
    }
    .input-group-mobile input:focus,
    .input-group-mobile input:not(:placeholder-shown) {
        top: 17px;
    }

    .input-group label {
        position: absolute;
        border: 0;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        padding: 0 53px;
        box-sizing: border-box;
        transition: all 0.1s ease-in-out;
        cursor: text;
    }
    .input-group-mobile label {
        position: absolute;
        border: 0;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        padding: 0 53px;
        box-sizing: border-box;
        transition: all 0.1s ease-in-out;
        cursor: text;
    }

    .input-group input:focus + label,
    .input-group input:not(:placeholder-shown) + label {
        bottom: 20px;
        font-size: 13px;
        opacity: 0.7;
    }

    .input-group-mobile input:focus + label,
    .input-group-mobile input:not(:placeholder-shown) + label {
        bottom: 20px;
        font-size: 13px;
        opacity: 0.7;
    }

    .req-mark {
        position: absolute;
        pointer-events: none;
        top: 0;
        right: 33px;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 22px;
        color: #e0e0e0;
        font-family: "Ubuntu", sans-serif;
    }



    .row-container {
        background: white;
    }

    .to-top {
        margin-top: -5%;
    }

    .to-left {
        text-align: left;
    }

    .to-right {
        float: right;
    }

    .to-right-mobile {
        float: right;
        margin-right: 2%;
    }

    .to-right-tablet {
        float: right;
        font-size: 12px;
    }

    .to-left span {
        color: black;
        font-weight: bold;
    }

    .table-donnees {
        border-collapse: collapse;
    }

    .table-donnees tr td {
        border: 1px solid lightgrey !important;
    }

    .List-cout li {
        list-style: none;
    }

    .list-boutons li {
        list-style: none;
    }

    .logo-assureur {
        border: 1px solid lightgrey;
    }

    .right--texting {
        text-align: right;
    }

    .right--texting ul li .col-lg-6:hover {
        background: #ffa409;
        color: white;
        text-decoration: none;
    }

    .answer {
        position: relative;
        margin-right: 0;
        float: left;
        display: block;
        margin-right: 2.12766%;
        width: 100%;
    }

    .highlight {
        padding: 6px 12px;
        display: -ms-flexbox;
        display: flex;
        position: relative;
        font-size: 0.0625rem;
        cursor: pointer;
        color: #6d6d6d;
        border: solid 1px transparent;
        border-bottom: solid 1px #e9e9e9;
        border-radius: 3px;
        transition: background 0.4s;
    }

    .highlight:hover {
        background-color: rgba(255, 164, 9, 0.3);
        padding-left: 10px;
        transition-duration: 0.5s;
    }

    ul li {
        list-style: none;
        padding-top: 7px;
    }

    .container {
        //padding: 0px !important;
    }

    .uppercase {
        font-weight: bold;
        color: #ffa409;
        text-transform: uppercase;
        font-size: 16px;
    }

    .head {
        background-color: rgb(91, 148, 188);
        color: white;
        font-size: 18px;
    }

    .selectatMobile {
        background: url(https://) no-repeat right;
        -webkit-appearance: none;
        background-position-x: 95%;
        border-bottom: 1px solid gray;
    }

    .selectatDesktop {
        background: url(https://) no-repeat right;
        -webkit-appearance: none;
        background-position-x: 90%;
        border-bottom: 1px solid gray;
    }

    .georgia {
        font-family: Georgia !important;
    }

    .border-radius {
        border-radius: 20px !important;
    }

    .card-desktop {
        height: 150px !important;
        width: 150px !important;
    }

    .form .plan input,
    .form .payment-plan input,
    .form .payment-type input {
        display: none;
    }

    .form label {
        /* margin-top: 15px; */
        width: 120px;
        position: relative;
        color: #333;
        font-family: Georgia !important;
        border-radius: 20px !important;
        background-color: #fff;
        font-size: 15px;
        text-align: center;
        height: 120px;
        display: block;
        cursor: pointer;
        border: 3px solid transparent;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    .form .plan input:checked+label,
    .form .payment-plan input:checked+label,
    .form .payment-type input:checked+label {
        border-radius: 20px !important;
        background-color: #ffa409;
        color: #fff;
    }

    .form .plan input:checked+label:after,
    form .payment-plan input:checked+label:after,
    .form .payment-type input:checked+label:after {
        content: "\2713";
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 100%;
        border: 2px solid #ffa409;
        background-color: #fff;
        color: #ffa409;
        z-index: 999;
        position: absolute;
        top: -10px;
        right: -10px;
    }

    /*================== CSS SELECT GLOBAL AUTO===================*/
    /* Reset Select */
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        appearance: none;
        outline: 0;
        box-shadow: none;

        background: #fff;
    }

    /* Remove IE arrow */
    select::-ms-expand {
        display: none;
    }

    select {
        flex: 1;
        padding: 0 0.5em;
        color: grey;
        cursor: pointer;
    }

    /*================== CSS SELECT DESKTOP AUTO===================*/
    /* Custom Select */
    .select {
        position: relative;
        display: flex;
        width: 100%;
        height: 3em;
        line-height: 3;
        background: #fff;
        overflow: hidden;
        border: 2px solid #d3d3d3 !important;
        border-radius: 35px;
    }

    /* Arrow */
    .select::after {
        content: "\2228";
        position: absolute;
        top: 0;
        right: 0;
        padding: 0 1em;
        background: #fff;
        cursor: pointer;
        pointer-events: none;
        -webkit-transition: 0.25s all ease;
        -o-transition: 0.25s all ease;
        transition: 0.25s all ease;
    }

    /* Transition */
    .select:hover::after {
        color: #f39c12;
    }

    /*css popup Free*/

    .containerP {
        margin-top: 15px;
        font-family: PT Sans, sans-serif;
        font-size: 18px;
        max-width: 500px;
        height: 500px;
        background: white;
        border-radius: 9px;
        overflow: hidden;
    }

    .icing,
    .dough {
        float: left;
        padding: 20px;
        box-sizing: border-box;
        height: 100%;
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        text-align: center;
    }

    .icing {
        width: 33%;
        position: relative;
        padding-right: 24px;
        background: -webkit-gradient(linear,
        left top,
        right top,
        from(#ffa409),
        color-stop(100%, #6c757d));
        background: linear-gradient(to right, #ffa409 100%, #6c757d 80%);
        color: white;
    }

    .icing:before {
        content: "";
        width: 36px;
        height: 36px;
        display: block;
        position: absolute;
        top: -18px;
        right: -7.2px;
        z-index: 1;
    }

    .dough {
        width: 67%;
        padding-left: 36px;
        color: black;
    }

    .order {
        -webkit-box-flex: 1;
        flex-grow: 1;
        /* padding: 20px 0;
            margin: 20px 0; */
        border: 1px solid white;
        border-color: white transparent;
        font-weight: bold;
        font-size: 18px;
        text-align: center;
    }

    .order li {
        display: -webkit-box;
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        text-align: center;
    }

    h2 {
        font-size: 1.2em;
    }

    .total {
        font-size: 22px;
        text-align: center;
        font-weight: bold;
    }

    .inputs {
        -webkit-box-flex: 1;
        flex-grow: 1;
    }

    .rowFree {
        width: 100%;
        display: -webkit-box;
        display: flex;
        -webkit-box-align: end;
        align-items: flex-end;
        margin-bottom: 6px;
    }

    .rowFreeMobile {
        /* width: 100%; */
        display: -webkit-box;
        display: flex;
        -webkit-box-align: end;
        align-items: flex-end;
        margin-bottom: 6px;
    }

    .column {
        width: 100%;
    }

    .column:not(:last-child) {
        margin-right: 10px;
    }

    .label,
    .text-input {
        float: left;
        display: block;
        clear: both;
    }

    .label {
        font-size: 0.8em;
        margin-bottom: 0.2em;
    }

    .text-input {
        box-sizing: border-box;
        width: 90%;
        padding: 10px;
        font-size: 1em;
        font-family: inherit;
        background: white;
        border: 1px solid #ffa409;
        border-radius: 5px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1) inset;
    }

    .name-group {
        -webkit-box-flex: 1;
        flex-grow: 1;
        flex-basis: 200px;
    }

    .order-button {
        padding: 10px 20px;
        width: 100%;
        box-sizing: border-box;
        font-size: 13px;
        font-family: inherit;
        color: inherit;
        background: rgba(255, 255, 255, 0.5);
        border: 1px solid rgba(144, 81, 14, 0.3);
        box-shadow: 0 2px 2px rgba(144, 81, 14, 0.1);
        border-radius: 5px;
        -webkit-transition: background 0.1s, color 0.1s, border-color 0.1s;
        transition: background 0.1s, color 0.1s, border-color 0.1s;
    }

    .buttonFRMobile {
        padding: 10px 20px;
        width: 100%;
        box-sizing: border-box;
        font-size: 13px;
        font-family: inherit;
        color: inherit;
        background: rgba(255, 255, 255, 0.5);
        border: 1px solid rgba(144, 81, 14, 0.3);
        box-shadow: 0 2px 2px rgba(144, 81, 14, 0.1);
        border-radius: 5px;
        -webkit-transition: background 0.1s, color 0.1s, border-color 0.1s;
        transition: background 0.1s, color 0.1s, border-color 0.1s;
    }

    .order-button:hover {
        background: #ffa409;
        color: white;
        border-color: transparent;
    }

    .policeLato {
        font-family: Lato, "Helvetica Neue", Arial, sans-serif
    }
    #error{
        color: red;
        font-weight: bold;
        font-size: 13px;
        position: absolute;
        font-family: Lato, "Helvetica Neue", Arial, sans-serif;
        float: left;
        margin-top: 50px;
        margin-left: 12px;
        z-index: 10000!important;


    }




    #container-question {
        /*width: 1000px!important;
        margin: 3% auto;
        margin-top: 0;
        max-width: 700px;
        min-width: 320px;
        padding: 3%;
        border-radius: 5px;*/

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
    }

    .label {
        display: inline-block;
        vertical-align: top;
        text-align: right;
        width: 20%;
    }

    .labels {
        display: block;
        vertical-align: top;
        text-align: center;
        width: auto;
    }

    .inputs {
        display: inline-block;
        vertical-align: bottom;
        text-align: left;
        width: auto;
        margin-bottom:10px ;
    }




    .inputBox{
        width: 80%
    }

    .painBox, .box{
        width: 100%;
        background: lightgrey;
        border-radius: 30px!important;
    }
    .box::placeholder {
        padding-left: 10px;
    }

    radio {
        text-align: left;
    }








    .input-group-textarea {
        display: block;
        width: 441px;
        max-width: 100%;
        height: 50px;
        margin-top: 30px;
        border: 0;
        background-color: #ffffff;
        border-bottom-left-radius: 41px;
        border-bottom-right-radius: 41px;
        border-top-left-radius: 41px;
        border-top-right-radius: 0;
        box-shadow: 0 17px 40px 0 rgba(75, 128, 182, 0.07);
        //margin-bottom: 22px;
        position: relative;
        font-size: 17px;
        color: #a7b4c1;
        transition: opacity 0.2s ease-in-out, filter 0.2s ease-in-out,
        box-shadow 0.1s ease-in-out;
    }

    .input-group-textareaplacehold::placeholder {
        display: flex;
        color: #a7b4c1;
        font-size: 14px;
        font-family: "Ubuntu", sans-serif;
        opacity: 0.7;
        margin-bottom: 10px;
    }
    .input-group-textarea:hover {
        box-shadow: 0 14px 44px 0 rgba(255,164,9, 0.077);
    }

    .input-group-textarea textarea {
        position: absolute;
        border: 0;
        box-shadow: none;
        background-color: white;
        top: 0;
        //margin-top: -20px;
        height: 50px;
        width: 100%;
        padding: 0 53px;
        box-sizing: border-box;
        border-bottom-left-radius: 41px;
        border-bottom-right-radius: 41px;
        border-top-left-radius: 41px;
        border-top-right-radius: 0;
        display: block;
        color: #1a6fc4;
        font-size: 17px;
        font-family: "Oxygen", sans-serif;
        transition: top 0.1s ease-in-out;
    }

    .input-group input::placeholder {
        color: rgba(0, 0, 0, 0);
    }

    .input-group-textarea label {
        position: absolute;
        border: 0;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        padding: 0 53px;
        box-sizing: border-box;
        transition: all 0.1s ease-in-out;
        cursor: text;
    }

    .input-group-textarea textarea:focus + label,
    .input-group-textarea textarea:not(:placeholder-shown) + label {
        bottom: 20px;
        font-size: 13px;
        opacity: 0.7;
    }












    .switch {
        position: relative;
        display: inline-block;
        width: 50px;
        height: 25px;
    }

    .switch input {
        display: none;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 16px;
        width: 16px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }

    input:checked + .slider {
        background-color: #ffa409;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #101010;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }





    /* Reset Select */
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        appearance: none;
        outline: 0;
        box-shadow: none;
        border: 0 !important;
        width: 200px;
        background: #fff;
        background-image: none;
    }
    /* Remove IE arrow */
    select::-ms-expand {
        display: none;
    }
    /* Custom Select */
    .select {
        position: relative;
        display: flex;
        width: 200px;
        height: 3em;
        line-height: 3;
        background: #2c3e50;
        overflow: hidden;
        border-radius: 30px;
    }
    select {
        flex: 1;
        padding: 0 .5em;
        color: grey;
        font-weight: bold;
        cursor: pointer;
    }
    /* Arrow */
    .select::after {
        content: '\25BC';
        position: absolute;
        top: 0;
        right: 0;
        padding: 0 1em;
        background: #34495e;
        cursor: pointer;
        pointer-events: none;
        -webkit-transition: .25s all ease;
        -o-transition: .25s all ease;
        transition: .25s all ease;
    }
    /* Transition */
    .select:hover::after {
        color: #f39c12;
    }

    #titre{
        font-size: 17px;
        font-weight: bold;
        color: #5a5a5a;
        margin-bottom: -25px;
    }

    .input-number[type=text]{
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        border-radius: 20px;
        /*border: 2px solid darkseagreen;*/
        color: #C9224D;
        width: 250px;
        height: 42px;
        font-weight: bold;
        background: #fff;
        padding-left: 10px;
    }

    .input-number[type=text]:focus {
        outline: none;
        border: 1px solid #fff;
        /* color: #2d9fd9;*/
    }


    .input-number[type=number]{
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        border-radius: 20px;
        /*border: 2px solid darkseagreen;*/
        color: #C9224D;
        width: 250px;
        height: 42px;
        font-weight: bold;
        background: #fff;
        padding-left: 10px;
    }

    .input-number[type=number]:focus {
        outline: none;
        border: 1px solid #fff;
        /* color: #2d9fd9;*/
    }

    #input-number{
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        border-radius: 20px;
        /*border: 2px solid darkseagreen;*/
        color: #C9224D;
        width: 250px;
        height: 42px;
        font-weight: bold;
        background: #fff;
        padding-left: 10px;
    }

    #input-number:focus {
        outline: none;
        border: 1px solid #fff;
        /* color: #2d9fd9;*/
    }

    #circle_number p {
        margin-top: 5px;
        font-weight: bold;
    }

    #circle_number {
        margin-bottom: 3px;
        background-color: #ffffff;
        display: inline-block;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        text-align: center;
        margin-top: 10px;
    }

    .select-css {
        display: block;
        font-size: 15px;
        font-family: Lato, "Helvetica Neue", Arial, sans-serif;
        font-weight: 500;
        float: right;
        color: #444;
        line-height: 1.3;
        padding: .6em 1.4em .5em .8em;
        box-sizing: border-box;
        margin: 0;
        border: 1px solid #aaa;
        box-shadow: 0 1px 0 1px rgba(0,0,0,.04);
        border-radius: .5em;
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        background-color: #fff;
        z-index: 3;
        position: relative;

        background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),
        linear-gradient(to bottom, #ffffff 0%,#e5e5e5 100%);
        background-repeat: no-repeat, repeat;
        background-position: right .7em top 50%, 0 0;
        background-size: .65em auto, 100%;
    }
    .select-css::-ms-expand {
        display: none;
    }
    .select-css:hover {
        border-color: #888;
    }
    .select-css:focus {
        border-color: #aaa;
        box-shadow: 0 0 1px 1px rgba(59, 153, 252, .7);
        box-shadow: 0 0 0 3px -moz-mac-focusring;
        color: #222;
        outline: none;
    }
    .select-css option {
        font-weight:normal;
    }








    .switchbutton.active {
        background-color: #ffa408;
        color: white;
    }

    .switchbutton {
        width: 250px;
        height: 35px;
        color: #8c8c8c;
        border-radius:30px;
        font-weight: 700;
        background-color: #f4efeb;
        border: none;
        letter-spacing: 2px;
        outline: none;
    }

    .notification{
        z-index: 4;
        width: 50%;
        height: 60px;
        border-radius: 50px 0px 5px 50px;
        margin: 0 auto;
        box-shadow: #95a5a6 0px 0px 8px 4px;
        color: white;
        line-height: 40px;
        overflow: hidden;
        animation: reveal 1 2s;
        position: fixed;
        bottom: 0;
        right: 0;
        float:right!important;
        background: #5B94BC!important;
    }

    .notification .close:hover{
        cursor: pointer;
    }

    @keyframes reveal{
        0%{
            transform: translate(0px, -50px);
        }
        50%{
            transform: translate(0px, -50px);
        }
        100%{
            transform: translate(0px, 0px);
        }
    }



    ul#menu li {
        display: inline!important;

    }

    #valeur{
        font-size: 25px;
        font-weight: bold;
        color: #DC143C;
        margin-top: -27px;
    }


    .card-mobile {
        width: auto;
        object-fit: contain;
        border-radius: 15px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
        background-color: #ffffff;
        margin-right: auto;
        margin-left: auto;
    }








    /* Reset Select */
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        appearance: none;
        outline: 0;
        box-shadow: none;
        border: 0 !important;
        //background: #2c3e50;
        background-image: none;
    }
    /* Remove IE arrow */
    select::-ms-expand {
        display: none;
    }
    /* Custom Select */
    .select {
        position: relative;
        display: flex;
        width: 20em;
        height: 3em;
        color: #4e555b;
        line-height: 3;
        //background: #2c3e50;
        overflow: hidden;
        border-radius: .25em;
    }
    select {
        flex: 1;
        padding: 0 .5em;
        color: #757575;
        cursor: pointer;
    }
    /* Arrow */
    .select::after {
        content: '\25BC';
        position: absolute;
        top: 0;
        right: 0;
        color: #757575;
        padding: 0 1em;
        background: #fff;
        cursor: pointer;
        pointer-events: none;
        -webkit-transition: .25s all ease;
        -o-transition: .25s all ease;
        transition: .25s all ease;
    }
    /* Transition */
    .select:hover::after {
        color: #f39c12;
    }


    .input-file input[type="file"] {
        visibility: hidden;
        width: 100%;
        height: 1px;
    }
    .input-file .btn {
        background-color: #ddd;
        border-color: #ccc;
        color: #333;
    }

    .wrap {
        display: table;
        width: 100%;
        //height: 100%;
        z-index: 3;
    }
    .valign-middle {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        float: left;
        margin-left: 9%;
    }
</style>
